module.exports = __webpack_public_path__ + "img/flag-in-hole.4371d173.svg";